import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Chart, Geom, Axis, Tooltip } from 'bizcharts'
import styles from './index.scss'

class Basic extends ComponentExt {
  state = {
    studyData: [],
  }
  componentDidMount() {
    this.fetchStudyData()
  }
  async fetchStudyData() {
    const { my } = await this.api.user.getUserStudyTrendData({
      staffid: undefined,
    })

    const studyData = []

    for (const val of my) {
      studyData.push({
        month: val.the_date.split('-')[1],
        学习时长: Math.round((val.study / 60) * 100) / 100,
      })
    }

    this.setState({
      studyData,
    })
  }
  render() {
    const cols = {
      value: {
        min: 0,
      },
      month: {
        range: [0, 1],
      },
    }

    const tickLine = { length: 5, tickCount: 3 }
    return (
      <div style={{ width: 375, height: 232 }}>
        <h3 className={styles.chartName}>时长图</h3>
        <Chart
          padding={[20, 20, 40, 70]}
          height={190}
          data={this.state.studyData}
          scale={cols}
          forceFit
        >
          <Axis name="month" />
          <Axis
            name="学习时长"
            label={{
              formatter: val => {
                return val + '小时'
              },
            }}
          />
          <Tooltip />
          <Geom type="area" position="month*学习时长" />
          <Geom type="line" position="month*学习时长" size={2} />
        </Chart>
      </div>
    )
  }
}

export default Basic
